<template>
  <div>
    <q-dialog
      :visible.sync="dialogVisible"
      title="新增sku"
      :innerHeight="'auto'"
      width="300px"
      @cancel="updateVal"
      @confirm="confirm"
      @close="updateVal"
    >
      <el-form :model="formData" label-width="50px" :rules="rules" ref="ruleForm" size="mini">
        <el-form-item label="行数" prop="rowNum">
          <el-input v-model.trim="formData.rowNum" placeholder=""></el-input>
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
import validator from 'validator';
export default {
  model: {
    prop: 'visible',
    event: 'input'
  },
  props: ['visible'],
  data() {
    return {
      dialogVisible: false,
      formData: {},
      rules: {
        rowNum: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.dialogVisible = this.visible;
  },
  methods: {
    updateVal() {
      this.dialogVisible = false;
      setTimeout(_=>{
        this.$emit('input', false)
      },200)
    },
    confirm() {
      this.$refs['ruleForm'].validate(valid=>{
        if(valid) {
          this.$emit('callback', this.formData);
          this.updateVal();
        }else{
        }
      })
    },
  }
}
</script>

<style>

</style>